import { NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Requestor, StorageBackend } from '@openid/appauth';
import { Browser } from 'ionic-appauth';
import { environment } from 'src/environments/environment';
import { CustomAuthService } from '../custom-auth.service';
import { GlobalStateQuery } from '../../state/global.appstate.query';
import { GlobalStateStore } from '../../state/global.appstate.store';

export const authFactory = (platform: Platform, ngZone: NgZone,
  requestor: Requestor, browser: Browser, storage: StorageBackend, state: GlobalStateQuery, store: GlobalStateStore) => {

  const authService = new CustomAuthService(browser, storage, requestor, state, store, platform);
  authService.authConfig = environment.auth_config;
  state.select('selectedServerName').subscribe(s => console.log(s));

  if (!platform.is('cordova')) {
    authService.authConfig.redirect_url = window.location.origin + '/callback';
    authService.authConfig.end_session_redirect_url = window.location.origin + '/endsession';
  }

  if (platform.is('cordova')) {
    (window as any).handleOpenURL = (callbackUrl) => {
      ngZone.run(() => {
        authService.authorizationCallback(callbackUrl);
      });
    };
  }

  return authService;
};
